// extracted by mini-css-extract-plugin
export var container = "styles-module__container___IHVIJ";
export var innerLabel = "styles-module__innerLabel___WwBFu";
export var label = "styles-module__label___zY7hU";
export var optionContainer = "styles-module__optionContainer___iEA0p";
export var radioButton = "styles-module__radioButton___X8WGa";